<div>
  <div class="warning">{{ 'SECURE_STORAGE_EXIT_WARNING' | translate }}</div>
  <div class="welcome">
    <img src="assets/images/suite/lock.svg" alt="" />
    <div class="welcome-message">
      <span class="welcome-message-1">{{ 'WELCOME_TO_ENCRYPTED_STORAGE' | translate }}</span>
      <span class="welcome-message-2">{{ 'ENTER_PASSWORD_TO_ENCRYPTED_STORAGE' | translate }}</span></div
    >
  </div>
  <form autocomplete="off" (ngSubmit)="enableSafeLock()">
    <div class="password-form mt-4">
      <span>{{ 'PASSWORD_ENTRY' | translate }}</span>
      <div class="password">
        <input
          autocomplete="off"
          [attr.autocomplete]="false"
          type="password"
          (keydown)="onKeyDown($event)"
          class="form-control input input-lg"
          id="txtSgeAktivasyonSifre"
          min="1"
          max="20"
          [placeholder]="'ENTER_PASSWORD' | translate"
        />
      </div>
      <a (click)="forgotSgePassword()" class="mb-8 password-link">{{ 'FORGOT_PASSWORD' | translate }}</a>
      <button type="submit" class="btn btn-primary btn-lg">{{ 'LOGIN' | translate }}</button>
    </div>
  </form>
</div>
